import { Component } from '@angular/core';

import { Store, createSelector } from '@ngrx/store';

import { COLOR_MAP } from '../../../../colors';
import { FreyaCommonModule } from '../../../../freya-common/freya-common.module';
import { eventTypeInfoMapV2 } from '../../../../global.constants';
import { strToTitleCase } from '../../../../js';
import { EventStatuses } from '../../../../schedules/dispatch/store/dispatch.reducer';
import { SharedModule } from '../../../../shared/shared.module';
import { 
  jobToolFeature, 
  selectPotentialEventLocations,
  selectJobEvents,
  getUserFullName
} from '../../../job-tool.reducer';

import { CreateEventDialogActions } from './timeline-create-event.actions';

export type EventType = 'estimating' | 'virtualEstimate' | 'moving' | 'delivery' | 'packing' | 'unpacking';

@Component({
  selector: 'app-timeline-create-event',
  standalone: true,
  imports: [
    FreyaCommonModule,
    SharedModule
  ],
  templateUrl: './timeline-create-event.component.html',
  styleUrl: './timeline-create-event.component.scss'
})
export class TimelineCreateEventComponent {

  public eventTypes = Object.values(eventTypeInfoMapV2).map((event) => ({
    name: event.name,
    value: event.value,
    backgroundColor: COLOR_MAP[event?.backgroundColor]?.color || 'white',
  }));

  public eventStatus = Object.values(EventStatuses).map((s) => ({
    label: strToTitleCase(s),
    value: s,
  }));

  public actions = CreateEventDialogActions;

  public viewModel$ = this.store.select(createSelector(
    jobToolFeature.selectCreateEventDialog,
    selectJobEvents,
    selectPotentialEventLocations,
    jobToolFeature.selectEventsLoading,
    (createEventDialog, jobEvents, potentialEventLocations, eventsLoading) => {

      const isEditMode = Boolean(createEventDialog.selectedEventId);

      const event = jobEvents.find((e) => e.event.id === createEventDialog.selectedEventId);

      const showDateTime = isEditMode && event?.event?.start;

      return {
        ...createEventDialog,
        attendeeSuggestions: createEventDialog.attendeeSuggestions.map((a) => ({
          ...a,
          name: getUserFullName(a.user),
        })),
        attendees: createEventDialog.attendees.map((a) => ({
          ...a,
          name: getUserFullName(a.user),
        })),
        event,
        isLoading: eventsLoading,
        isEditMode: Boolean(createEventDialog.selectedEventId),
        potentialEventLocations,
        header: this._getHeader(createEventDialog.title, createEventDialog.eventType, isEditMode),
        showDateTime,
      }
    },
  ))

  private _getHeader(title: string, eventType: EventType, isEditMode: boolean) {

    if (!eventType) { return; }

    const formattedEventType = eventTypeInfoMapV2[eventType].name;

    if (!isEditMode) {
      return `New ${formattedEventType} Event`;
    }

    const hasCustomTitle = title !== formattedEventType;

    if (hasCustomTitle) {
      return `Edit ${title}`;
    }

    return `Edit ${formattedEventType} Event`;
  }

  constructor(public store: Store) { }
}
